"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteComputer = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 150 86",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M41.2983478,0 L114.25615,0 C117.43731,6.11558756e-15 120.01615,2.57884005 120.01615,5.76000046 C120.01615,6.05877547 119.992904,6.35709761 119.946622,6.65226611 L111.896916,57.9896907 L111.896916,57.9896907 L27.2783527,57.9896907 L35.6078765,4.86773422 C36.047298,2.06530114 38.4616733,-5.69616028e-15 41.2983478,0 Z",
        id: "mysite-computer-path-1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0,50.257732 L89.072172,50.257732 L89.072172,53.0028861 C89.072172,56.1840466 86.493332,58.7628866 83.3121716,58.7628866 L5.76000046,58.7628866 C2.57884005,58.7628866 -4.98598628e-16,56.1840466 0,53.0028861 L0,50.257732 L0,50.257732 Z",
        id: "mysite-computer-path-2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.75867954,0 L31.9341025,0 C32.7824118,1.57311275e-15 33.4701023,0.68769057 33.4701023,1.53599988 L33.4701023,20.9594237 C33.4701023,27.7458981 27.9685778,33.2474227 21.1821033,33.2474227 L12.5106787,33.2474227 C5.72420421,33.2474227 0.222679657,27.7458981 0.222679657,20.9594237 L0.222679657,1.53599988 C0.222679657,0.68769057 0.910370227,1.55831892e-16 1.75867954,0 Z",
        id: "mysite-computer-path-3"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-966.000000, -1179.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(966.000000, 1179.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M84.2503307,13.8956646 C76.3194583,13.6160937 68.7652041,11.0096658 61.5525332,8.15847754 C54.3398622,5.3072892 47.1939753,2.14715866 39.4536014,0.636170264 C34.4743624,-0.335257122 28.7802061,-0.472323025 24.7687875,2.24397506 C20.9073591,4.85475415 19.6603597,9.37357762 18.9903302,13.5573511 C18.4856184,16.7120425 18.1889223,20.0244685 19.5705845,22.9746489 C20.5307412,25.0230227 22.2353752,26.7439612 23.4144958,28.705309 C27.5145948,35.5314085 24.6187972,43.9489955 20.1716404,50.6140969 C18.0914834,53.7405049 15.6686478,56.7233199 14.060358,60.0509755 C12.4520681,63.3786311 11.7075909,67.192544 13.1144339,70.5876447 C14.5103288,73.953374 17.8342008,76.4803907 21.4350621,78.2578962 C28.7495512,81.8694742 37.3690651,82.9029073 45.7739944,83.4881568 C64.3793569,84.7837559 83.0843481,84.2224387 101.738978,83.661121 C108.642909,83.4522586 115.576401,83.2423087 122.368661,82.155572 C126.13922,81.5518291 130.032398,80.5945434 132.769446,78.2818285 C136.245499,75.3447019 137.107121,70.3766068 134.777346,66.6964964 C130.874314,60.5252669 120.07173,58.9936101 117.34125,52.3665824 C115.838063,48.7201942 117.381759,44.6582571 119.565924,41.2707712 C124.251751,34.0160688 132.105986,27.6512069 132.519828,19.357632 C132.804481,13.6617823 129.028448,7.95722997 123.190871,5.26268839 C117.07083,2.43434436 108.585979,2.79332649 104.070943,7.46879669 C99.4223396,12.2911233 91.2527964,14.1436886 84.2503307,13.8956646 Z",
            fill: "#EDE4E8",
            fillRule: "nonzero",
            className: "fill-primary",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(0.000000, 25.515464)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M59.5670148,0 L118.895326,0 C122.076486,2.08016557e-15 124.655326,2.57884005 124.655326,5.76000046 C124.655326,6.05877547 124.63208,6.35709761 124.585797,6.65226611 L116.536092,57.9896907 L116.536092,57.9896907 L50.4742302,57.9896907 L59.5670148,0 Z",
              className: "fill-primary",
              fill: "#661B39"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary",
                fill: "#661B39",
                xlinkHref: "#mysite-computer-path-1"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.493116259",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-computer-path-1"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              fill: "#FFFFFF",
              points: "40.6391788 4.63917526 115.42269 4.63917526 107.443308 57.9896907 32.6597964 57.9896907"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              className: "fill-primary",
              fill: "#661B39",
              points: "69.5876316 50.257732 117.761523 50.257732 116.487726 58.7628866 69.5876316 58.7628866"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary",
                fill: "#661B39",
                xlinkHref: "#mysite-computer-path-2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.493116259",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-computer-path-2"
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "70.7796392 40.2061856 100.515464 40.2061856 100.096649 44.0721649 70.3608247 44.0721649"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "70.0064433 46.3917526 99.742268 46.3917526 99.3234536 50.257732 69.5876289 50.257732"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            stroke: "#C3D0D8",
            strokeWidth: "1.5",
            points: "50.257732 40.2061856 62.628866 40.2061856 61.0824742 51.0309278 48.7113402 51.0309278"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            stroke: "#C3D0D8",
            strokeWidth: "1.5",
            points: "47.1649485 55.6701031 59.5360825 55.6701031 57.9896907 66.4948454 45.6185567 66.4948454"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "67.6868557 56.1633906 97.4226804 56.1633906 97.003866 60.0293699 67.2680412 60.0293699"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "66.9136598 62.3489576 96.6494845 62.3489576 96.2306701 66.214937 66.4948454 66.214937"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(106.701031, 51.030928)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                fill: "white",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                  xlinkHref: "#mysite-computer-path-3"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fill: "#C3D0D8",
                xlinkHref: "#mysite-computer-path-3"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M-7.51967098,0 L22.6557519,0 C23.5040613,1.57311275e-15 24.1917518,0.68769057 24.1917518,1.53599988 L24.1917518,20.9594237 C24.1917518,27.7458981 18.6902273,33.2474227 11.9037528,33.2474227 L3.23232817,33.2474227 C-3.5541463,33.2474227 -9.05567086,27.7458981 -9.05567086,20.9594237 L-9.05567086,1.53599988 C-9.05567086,0.68769057 -8.36798029,1.55831892e-16 -7.51967098,0 Z",
                fill: "#FFFFFF",
                mask: "url(#mask-4)"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "0.222679657",
              y: "4.75051509",
              width: "33.2474227",
              height: "4.75051509"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "23.9752551",
              y: "4.75051509",
              width: "9.50103017",
              height: "4.75051509"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M33.4762853,4.75051509 C38.7235593,4.75051509 42.9773154,9.00427119 42.9773154,14.2515453 C42.9773154,19.4988193 38.7235593,23.7525754 33.4762853,23.7525754 L33.4762853,19.0020603 L33.4762853,19.0020603 C36.0999223,19.0020603 38.2268003,16.8751823 38.2268003,14.2515453 C38.2268003,11.6279082 36.0999223,9.50103017 33.4762853,9.50103017 L33.4762853,4.75051509 L33.4762853,4.75051509 Z",
              fill: "#C3D0D8"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
            stroke: "#1C895D",
            strokeWidth: "3",
            points: "50.257732 43.2289553 54.0670853 48.2180527 63.9539067 39.7128981"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
            stroke: "#1C895D",
            strokeWidth: "3",
            points: "47.1649485 59.1861603 50.9743018 64.1752577 60.8611232 55.6701031"
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteComputer')(IllustrationMySiteComputer);